'use strict';

import { resetCoordinate } from '../main';

export const click = (() => {

    /**
     * init
     */
    const init = () => {
        let scrollTop = 0;

        $('.js-hamburger').on('click', function() {
			const $body = $('body');

			if(!$body.hasClass('on-hamburger')){
                scrollTop = $(window).scrollTop();
				$body.css('top', -scrollTop + 'px');
				$body.addClass('on-hamburger');
			} else {
				$body.css('top', '');
				$body.removeClass('on-hamburger');
                window.scrollTo(0, scrollTop);
			}
        });

		$('.coordinate__item:nth-of-type(n + 2)').hide();
		$('.js-tab').on('click', function(event) {
			const $this = $(event.currentTarget);
			const data = $this.data('tab');

			$('.js-tab').removeClass('is-active');
			$this.addClass('is-active');

			$('.coordinate__item').fadeOut(150);
			setTimeout(function(){
				$('#tab-' + data).fadeIn(150)
				$('.js-carousel-coordinate').slick('unslick');
				resetCoordinate();
			}, 300);

		});
    };

    // public
    return {
        init: init
    };
})();
